const appCurrentVersion = {
  majorVer: 11,
  minorVer: 26,
  revision: 5,
};
const icsAppCurrentVersion = {
  majorVer: 5,
  minorVer: 3,
  revision: 4,
};
let icsSetWebViewVersion = null;
const isPord = process.env.NODE_ENV === 'production';
if (isPord) {
  icsSetWebViewVersion = {
    majorVer: 5,
    minorVer: 4,
    revision: 9,
  };
} else {
  icsSetWebViewVersion = {
    majorVer: 5,
    minorVer: 4,
    revision: 3,
  };
}
export default {
  appCurrentVersion,
  icsAppCurrentVersion,
  icsSetWebViewVersion,
};
